import React from 'react';
import { Badge, Text, Box } from '@wix/design-system';
import s from './CheckoutPage.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { CycleDetails } from 'types';

export interface CheckoutRowLabelProps {
  formatCurrency: any;
  cycleString: string;
  cycleMonthlyPrice: number;
  monthlyFullPrice: number | undefined;
  showDiscountSavings: boolean;
  showStrikedPrice: boolean;
  currentCycle: CycleDetails;
}

export const CheckoutRowLabel: React.FC<{
  props: CheckoutRowLabelProps;
}> = ({ props }) => {
  const { t } = useTranslation();
  const [currencyToString] = usePremiumCurrencyFormatter();

  const { fullTermDisplaySavings } = props.currentCycle;

  const str = t('Advanced.Plans_General_checkout.savings', {
    savingsPrice: currencyToString(fullTermDisplaySavings),
  });

  const stylizedString = (
    <div className={classNames(s.savingsBadgeText)}>{str}</div>
  );

  const showDiscountSavings =
    props.showDiscountSavings && fullTermDisplaySavings > 0;
  const showStrikedPrice =
    showDiscountSavings &&
    props.showStrikedPrice &&
    !!props.monthlyFullPrice &&
    props.monthlyFullPrice > props.cycleMonthlyPrice;

  return (
    <div>
      <Text>
        {showStrikedPrice && (
          <>
            <span
              className={classNames(s.strikethroughPrice)}
              data-hook='striked-price'
            >
              {props.formatCurrency(props.monthlyFullPrice)}
            </span>{' '}
          </>
        )}
        {`${props.formatCurrency(props.cycleMonthlyPrice)} ${
          props.cycleString
        }`}
      </Text>
      {showDiscountSavings && (
        <Box>
          <Badge
            className={classNames(s.savingsBadge)}
            dataHook='checkout-savings-badge'
            size='medium'
            skin='success'
            type='outlined'
          >
            {stylizedString}
          </Badge>
        </Box>
      )}
    </div>
  );
};

export default CheckoutRowLabel;
